import { OWF_IMPROVE_TERMS_TOUCHPOINTS_PDP_240528 } from "@faire/web-api/indigofair/settings/OWF_IMPROVE_TERMS_TOUCHPOINTS_PDP_240528";

import {
  getSettingValueAndAssign,
  getSettingValueWithoutAssignment,
} from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingOwFImproveTermsTouchpointsPDP = (): boolean =>
  getSettingValueWithoutAssignment(
    OWF_IMPROVE_TERMS_TOUCHPOINTS_PDP_240528,
    false
  );

export const getSettingAndAssignOwFImproveTermsTouchpointsPDP = (): boolean =>
  getSettingValueAndAssign(OWF_IMPROVE_TERMS_TOUCHPOINTS_PDP_240528, false);
